import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getOfferByOfferNumber } from "../Ponude/modules/actions";

const mapStateToProps = (state) => ({
  offer: state.offersReducer.offerToEdit,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      getOfferByOfferNumber,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
